export default function insertIntoArray(source, index, item, replaceAtIndex = true, addToStart = false) {
  if (addToStart) {
    return [item, ...source.slice(0, index), ...source.slice(replaceAtIndex ? index + 1 : index)];
  }
  return [...source.slice(0, index), item, ...source.slice(replaceAtIndex ? index + 1 : index)];
}
